import { Typography, styled } from '@mui/material';
import getConfig from 'next/config';

import { WidgetType } from '../../../types/widget';
import WidgetImagesProvider from '../../settings/widgets/provider/WidgetImagesProvider';
import { PublicRuntimeConfigType } from '../../types/publicRuntimeConfig';
import DesktopDashboard from '../dashboard/DesktopDashboard';
import { useSession } from '../session/SessionContext';

const InfoWrapper = styled('div')(({ theme: { spacing } }) => ({
	height: '100%',
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	gap: spacing(2),
}));

type DesktopHomepageProps = {
	widgetsWithKey?: {
		key: string;
		widget: WidgetType;
	}[];
	loading: boolean;
};

const DesktopHomepage = ({ widgetsWithKey, loading }: DesktopHomepageProps) => {
	const { customerFile: sessionCustomerFile } = useSession();
	const { publicRuntimeConfig } = getConfig() as PublicRuntimeConfigType;
	const { standaloneModule } = publicRuntimeConfig;

	return (
		<>
			{!sessionCustomerFile && (
				<InfoWrapper>
					<Typography variant="h6">Aucun dossier</Typography>
					<Typography variant="body2">Aucun dossier client n&apos;est disponible</Typography>
				</InfoWrapper>
			)}

			{sessionCustomerFile && !standaloneModule ? (
				<WidgetImagesProvider>
					<DesktopDashboard widgetsWithKey={widgetsWithKey} loading={loading} />
				</WidgetImagesProvider>
			) : null}
		</>
	);
};

export default DesktopHomepage;
